import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PinCodeService {

  private _reset = new Subject();
  reset$ = this._reset.asObservable();

  reset(option: boolean) {
    this._reset.next(option);
  }

}
